import PageContainerBlank from '../../components/PageContainer/PageContainerBlank';
import PageEndBlank from '../../components/PageContainer/PageEndBlank';
import PrayerInstructions from '../../components/PrayerInstructions/PrayerInstructions';
import SimpleImage from '../../components/SimpleImage/SimpleImage';
import FlexColumn from '../../components/FlexColumn/FlexColumn.js';
import { useState } from 'react';

const DivineMercyChaplet = () => {
	const EMPTY = "Empty";
	const EmptyPrayer = (
		<div></div>
	);

	const DAY_1 = "Day 1";
	const Day1Prayer = (
		<div>
			<strong>Today bring to Me ALL MANKIND, ESPECIALLY ALL SINNERS, and immerse them in the ocean of My mercy. In this way you will console Me in the bitter grief into which the loss of souls plunges Me.</strong>
			<p>Most Merciful Jesus, whose very nature it is to have compassion on us and to forgive us, do not look upon our sins but upon our trust which we place in Your infinite goodness. Receive us all into the abode of Your Most Compassionate Heart, and never let us escape from It. We beg this of You by Your love which unites You to the Father and the Holy Spirit.</p>
			<p>Eternal Father, turn Your merciful gaze upon all mankind and especially upon poor sinners, all enfolded in the Most Compassionate Heart of Jesus. For the sake of His sorrowful Passion show us Your mercy, that we may praise the omnipotence of Your mercy for ever and ever. Amen.</p>
		</div>
	);

	const DAY_2 = "Day 2";
	const Day2Prayer = (
		<div>
			<strong>Today bring to Me THE SOULS OF PRIESTS AND RELIGIOUS, and immerse them in My unfathomable mercy. It was they who gave Me strength to endure My bitter Passion. Through them as through channels My mercy flows out upon mankind.</strong>
			<p>Most Merciful Jesus, from whom comes all that is good, increase Your grace in men and women consecrated to Your service, that they may perform worthy works of mercy; and that all who see them may glorify the Father of Mercy who is in heaven.</p>
			<p>Eternal Father, turn Your merciful gaze upon the company of chosen ones in Your vineyard—upon the souls of priests and religious; and endow them with the strength of Your blessing. For the love of the Heart of Your Son in which they are enfolded, impart to them Your power and light, that they may be able to guide others in the way of salvation and with one voice sing praise to Your boundless mercy for ages without end. Amen.</p>
		</div>
	);

	const DAY_3 = "Day 3";
	const Day3Prayer = (
		<div>
			<strong>Today bring to Me ALL DEVOUT AND FAITHFUL SOULS, and immerse them in the ocean of My mercy. These souls brought Me consolation on the Way of the Cross. They were that drop of consolation in the midst of an ocean of bitterness.</strong>
			<p>Most Merciful Jesus, from the treasury of Your mercy, You impart Your graces in great abundance to each and all. Receive us into the abode of Your Most Compassionate Heart and never let us escape from It. We beg this grace of You by that most wonderous love for the heavenly Father with which Your Heart burns so fiercely.</p>
			<p>Eternal Father, turn Your merciful gaze upon faithful souls, as upon the inheritance of Your Son. For the sake of His sorrowful Passion, grant them Your blessing and surround them with Your constant protection. Thus may they never fail in love or lose the treasure of the holy faith, but rather, with all the hosts of Angels and Saints, may they glorify Your boundless mercy for endless ages. Amen.</p>
		</div>
	);

	const DAY_4 = "Day 4";
	const Day4Prayer = (
		<div>
			<strong>Today bring to Me The PAGANS AND THOSE WHO DO NOT YET KNOW ME. I was thinking also of them during My bitter Passion, and their future zeal comforted My Heart. Immerse them in the ocean of My mercy.</strong>
			<p>Most compassionate Jesus, You are the Light of the whole world. Receive into the abode of Your Most Compassionate Heart the souls of those who do not believe in God and of those who as yet do not know You. Let the rays of Your grace enlighten them that they, too, together with us, may extol Your wonderful mercy; and do not let them escape from the abode which is Your Most Compassionate Heart.</p>
			<p>Eternal Father, turn Your merciful gaze upon the souls of those who do not believe in You, and of those who as yet do not know You, but who are enclosed in the Most Compassionate Heart of Jesus. Draw them to the light of the Gospel. These souls do not know what great happiness it is to love You. Grant that they, too, may extol the generosity of Your mercy for endless ages. Amen.</p>
		</div>
	);

	const DAY_5 = "Day 5";
	const Day5Prayer = (
		<div>
			<strong>Today bring to Me THE SOULS OF HERETICS AND SCHISMATICS, and immerse them in the ocean of My mercy. During My bitter Passion they tore at My Body and Heart, that is, My Church. As they return to unity with the Church, My wounds heal and in this way they alleviate My Passion.</strong>
			<p>Most Merciful Jesus, Goodness Itself, You do not refuse light to those who seek it of You. Receive into the abode of Your Most Compassionate Heart the souls of those who have separated themselves from Your Church. Draw them by Your light into the unity of the Church, and do not let them escape from the abode of Your Most Compassionate Heart; but bring it about that they, too, come to glorify the generosity of Your mercy.</p>
			<p>Eternal Father, turn Your merciful gaze upon the souls of those who have separated themselves from Your Son's Church, who have squandered Your blessings and misused Your graces by obstinately persisting in their errors. Do not look upon their errors, but upon the love of Your own Son and upon His bitter Passion, which He underwent for their sake, since they, too, are enclosed in His Most Compassionate Heart. Bring it about that they also may glorify Your great mercy for endless ages. Amen.</p>
		</div>
	);

	const DAY_6 = "Day 6";
	const Day6Prayer = (
		<div>
			<strong>Today bring to Me THE MEEK AND HUMBLE SOULS AND THE SOULS OF LITTLE CHILDREN, and immerse them in My mercy. These souls most closely resemble My Heart. They strengthened Me during My bitter agony. I saw them as earthly Angels, who will keep vigil at My altars. I pour out upon them whole torrents of grace. Only the humble soul is capable of receiving My grace. I favor humble souls with My confidence.</strong>
			<p>Most Merciful Jesus, You yourself have said, "Learn from Me for I am meek and humble of heart." Receive into the abode of Your Most Compassionate Heart all meek and humble souls and the souls of little children. These souls send all heaven into ecstasy and they are the heavenly Father's favorites. They are a sweet-smelling bouquet before the throne of God; God Himself takes delight in their fragrance. These souls have a permanent abode in Your Most Compassionate Heart, O Jesus, and they unceasingly sing out a hymn of love and mercy.</p>
			<p>Eternal Father, turn Your merciful gaze upon meek souls, upon humble souls, and upon little children who are enfolded in the abode which is the Most Compassionate Heart of Jesus. These souls bear the closest resemblance to Your Son. Their fragrance rises from the earth and reaches Your very throne. Father of mercy and of all goodness, I beg You by the love You bear these souls and by the delight You take in them: Bless the whole world, that all souls together may sing out the praises of Your mercy for endless ages. Amen.</p>
		</div>
	);

	const DAY_7 = "Day 7";
	const Day7Prayer = (
		<div>
			<strong>Today bring to Me THE SOULS WHO ESPECIALLY VENERATE AND GLORIFY MY MERCY, and immerse them in My mercy. These souls sorrowed most over my Passion and entered most deeply into My spirit. They are living images of My Compassionate Heart. These souls will shine with a special brightness in the next life. Not one of them will go into the fire of hell. I shall particularly defend each one of them at the hour of death.</strong>
			<p>Most Merciful Jesus, whose Heart is Love Itself, receive into the abode of Your Most Compassionate Heart the souls of those who particularly extol and venerate the greatness of Your mercy. These souls are mighty with the very power of God Himself. In the midst of all afflictions and adversities they go forward, confident of Your mercy; and united to You, O Jesus, they carry all mankind on their shoulders. These souls will not be judged severely, but Your mercy will embrace them as they depart from this life.</p>
			<p>Eternal Father, turn Your merciful gaze upon the souls who glorify and venerate Your greatest attribute, that of Your fathomless mercy, and who are enclosed in the Most Compassionate Heart of Jesus. These souls are a living Gospel; their hands are full of deeds of mercy, and their hearts, overflowing with joy, sing a canticle of mercy to You, O Most High! I beg You O God:</p>
			<p>Show them Your mercy according to the hope and trust they have placed in You. Let there be accomplished in them the promise of Jesus, who said to them that during their life, but especially at the hour of death, the souls who will venerate this fathomless mercy of His, He, Himself, will defend as His glory. Amen.</p>
		</div>
	);

	const DAY_8 = "Day 8";
	const Day8Prayer = (
		<div>
			<strong>Today bring to Me THE SOULS WHO ARE DETAINED IN PURGATORY, and immerse them in the abyss of My mercy. Let the torrents of My Blood cool down their scorching flames. All these souls are greatly loved by Me. They are making retribution to My justice. It is in your power to bring them relief. Draw all the indulgences from the treasury of My Church and offer them on their behalf. Oh, if you only knew the torments they suffer, you would continually offer for them the alms of the spirit and pay off their debt to My justice.</strong>
			<p>Most Merciful Jesus, You Yourself have said that You desire mercy; so I bring into the abode of Your Most Compassionate Heart the souls in Purgatory, souls who are very dear to You, and yet, who must make retribution to Your justice. May the streams of Blood and Water which gushed forth from Your Heart put out the flames of Purgatory, that there, too, the power of Your mercy may be celebrated.</p>
			<p>Eternal Father, turn Your merciful gaze upon the souls suffering in Purgatory, who are enfolded in the Most Compassionate Heart of Jesus. I beg You, by the sorrowful Passion of Jesus Your Son, and by all the bitterness with which His most sacred Soul was flooded: Manifest Your mercy to the souls who are under Your just scrutiny. Look upon them in no other way but only through the Wounds of Jesus, Your dearly beloved Son; for we firmly believe that there is no limit to Your goodness and compassion. Amen.</p>
		</div>
	);

	const DAY_9 = "Day 9";
	const Day9Prayer = (
		<div>
			<strong>Today bring to Me SOULS WHO HAVE BECOME LUKEWARM, and immerse them in the abyss of My mercy. These souls wound My Heart most painfully. My soul suffered the most dreadful loathing in the Garden of Olives because of lukewarm souls. They were the reason I cried out: 'Father, take this cup away from Me, if it be Your will.' For them, the last hope of salvation is to run to My mercy.</strong>
			<p>Most compassionate Jesus, You are Compassion Itself. I bring lukewarm souls into the abode of Your Most Compassionate Heart. In this fire of Your pure love, let these tepid souls, who, like corpses, filled You with such deep loathing, be once again set aflame. O Most Compassionate Jesus, exercise the omnipotence of Your mercy and draw them into the very ardor of Your love, and bestow upon them the gift of holy love, for nothing is beyond Your power.</p>
			<p>Eternal Father, turn Your merciful gaze upon lukewarm souls who are nonetheless enfolded in the Most Compassionate Heart of Jesus. Father of Mercy, I beg You by the bitter Passion of Your Son and by His three-hour agony on the Cross: Let them, too, glorify the abyss of Your mercy. Amen.</p>
		</div>
	);

	const [novenaKey, setNovenaKey] = useState(EMPTY);
	const [novenaPrayer, setNovenaPrayer] = useState("");
	const handleChange = (event) => {
		switch (event.target.value) {
			case DAY_1:
				setNovenaKey(DAY_1);
				setNovenaPrayer(Day1Prayer);
				break;
			case DAY_2:
				setNovenaKey(DAY_2);
				setNovenaPrayer(Day2Prayer);
				break;
			case DAY_3:
				setNovenaKey(DAY_3);
				setNovenaPrayer(Day3Prayer);
				break;
			case DAY_4:
				setNovenaKey(DAY_4);
				setNovenaPrayer(Day4Prayer);
				break;
			case DAY_5:
				setNovenaKey(DAY_5);
				setNovenaPrayer(Day5Prayer);
				break;
			case DAY_6:
				setNovenaKey(DAY_6);
				setNovenaPrayer(Day6Prayer);
				break;
			case DAY_7:
				setNovenaKey(DAY_7);
				setNovenaPrayer(Day7Prayer);
				break;
			case DAY_8:
				setNovenaKey(DAY_8);
				setNovenaPrayer(Day8Prayer);
				break;
			case DAY_9:
				setNovenaKey(DAY_9);
				setNovenaPrayer(Day9Prayer);
				break;
			default:
				setNovenaKey(EMPTY);
				setNovenaPrayer(EmptyPrayer);
				break;
		}
	};

	const instructions = [
		{imageKey: "crucifix", title: "Make the Sign of the Cross", descriptionElements: (
			<div>
				<p style={{ textAlign: 'left' }}>
					Daily Novena prayer:&nbsp;
					<select value={novenaKey} onChange={handleChange}>
						<option value={EMPTY} disabled> -- Choose a day -- </option>
						<option value={DAY_1}>Day 1 (Good Friday)</option>
						<option value={DAY_2}>Day 2 (Holy Saturday)</option>
						<option value={DAY_3}>Day 3 (Easter Sunday)</option>
						<option value={DAY_4}>Day 4 (Easter Monday)</option>
						<option value={DAY_5}>Day 5 (Easter Tuesday)</option>
						<option value={DAY_6}>Day 6 (Easter Wednesday)</option>
						<option value={DAY_7}>Day 7 (Easter Thursday)</option>
						<option value={DAY_8}>Day 8 (Easter Friday)</option>
						<option value={DAY_9}>Day 9 (Easter Saturday)</option>
					</select>
				</p>
				{novenaPrayer}
			</div>
		)},
		{imageKey: "largebead", title: "Optional Opening Prayers", descriptionElements: (
			<div>
				<p>You expired, Jesus, but the source of life gushed forth for souls, and the ocean of mercy opened up for the whole world. O Fount of Life, unfathomable Divine Mercy, envelop the whole world and empty Yourself out upon us.</p>
				<p>O Blood and Water, which gushed forth from the Heart of Jesus as a fount of mercy for us, I trust in You!&nbsp;&nbsp;<em className='highlight'>(Pray this three times)</em></p>
			</div>
		)},
		{imageKey: "smallbead", title: "Our Father", descriptionElements: (<div></div>)},
		{imageKey: "smallbead", title: "Hail Mary", descriptionElements: (<div></div>)},
		{imageKey: "smallbead", title: "The Apostles' Creed", descriptionElements: (<div></div>)},
		{imageKey: "largebead", title: "The Eternal Father", descriptionElements: (
			<div>
				<p>Eternal Father, I offer You the Body and Blood, Soul and Divinity of Your Dearly Beloved Son, Our Lord, Jesus Christ, in atonement for our sins and those of the whole world.</p>
				<em className='highlight'>(Pray for each decade)</em>
			</div>
		)},
		{imageKey: "smallbead", title: "For the sake of His sorrowful Passion", descriptionElements: (
			<div>
				<p>For the sake of His sorrowful Passion, have mercy on us and on the whole world.</p>
				<em className='highlight'>(Pray for each of the 10 beads in the decade)</em>
			</div>
		)},
		{imageKey: "medallion", title: "Holy God", descriptionElements: (
			<div>
				<p>Holy God, Holy Mighty One, Holy Immortal One, have mercy on us and on the whole world.&nbsp;&nbsp;<em className='highlight'>(Pray this three times)</em></p>
			</div>
		)},
		{imageKey: "", title: "Optional Closing Prayers", descriptionElements: (
			<div>
				<p>Eternal God, in Whom mercy is endless and the treasury of compassion inexhaustible, look kindly upon us and increase Your mercy in us, that in difficult moments we might not despair nor become despondent, but with great confidence submit ourselves to Your holy will, which is Love and Mercy itself.</p>
				<p>Amen.</p>
			</div>
		)},
		{imageKey: "crucifix", title: "Make the Sign of the Cross", descriptionElements: (<div></div>)},
	];

	return (
		<div className='justify'>
			<PageContainerBlank />

			<h1>Divine Mercy Chaplet</h1>
			<p className='centered'>The Divine Mercy Chaplet is prayed on a regular rosary!</p>
			<p className='centered'>Extra opening and closing prayers are available at <a href="https://www.thedivinemercy.org/message/devotions/pray-the-chaplet" target="_blank" rel="noreferrer">The Divine Mercy</a>.</p>
			<FlexColumn>
				<SimpleImage style={{ maxWidth: '300px' }} src="/static/images/prayer/DivineMercy.jpg" alt="Divine Mercy" width="523px" height="655px" />
			</FlexColumn>
			<br />

			<PrayerInstructions instructions={instructions} />

			<PageEndBlank />
		</div>
	);
};

export default DivineMercyChaplet;